// extracted by mini-css-extract-plugin
export default {"root":"AddTimeFloatBtn_root__zHvSA","appearance":"AddTimeFloatBtn_appearance__dqrMN"};